export default "__VITE_ASSET__CYy05sZi__"